import { render, staticRenderFns } from "./OverlayRealtime.vue?vue&type=template&id=ec44749c&scoped=true&"
import script from "./OverlayRealtime.vue?vue&type=script&lang=js&"
export * from "./OverlayRealtime.vue?vue&type=script&lang=js&"
import style0 from "./OverlayRealtime.vue?vue&type=style&index=0&id=ec44749c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec44749c",
  null
  
)

export default component.exports